import { useState } from 'react';
import type { SaunaType } from '../types/design';

export function useRenderPhoto() {
  const [renderLoading, setRenderLoading] = useState(false);
  const [renderResult, setRenderResult] = useState<string | null>(null);
  const [renderError, setRenderError] = useState<string | null>(null);

  const renderPhoto = async ({ width, length, saunaType }: { width: number; length: number; saunaType: SaunaType }) => {
    setRenderLoading(true);
    setRenderError(null);
    setRenderResult(null);
    try {
      const renderServerUrl = (import.meta.env.VITE_RENDER_SERVER_URL ?? 'http://localhost:3001').replace(/\/$/, '');
      const renderPayload = {
        W: width,
        L: length,
        saunaType,
        woodType: 'pine',
        resolution: { x: 1920, y: 1080 },
        samples: 128,
      };
      const tokenRes = await fetch(`${renderServerUrl}/api/render-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(renderPayload),
      });
      if (!tokenRes.ok) throw new Error('Rendering är inte tillgänglig just nu');
      const tokenData = await tokenRes.json();
      if (!tokenData.token || typeof tokenData.token !== 'string') {
        throw new Error('Rendering är inte tillgänglig just nu');
      }

      const res = await fetch(`${renderServerUrl}/api/render-sauna`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenData.token}`,
        },
        body: JSON.stringify(renderPayload),
      });
      if (!res.ok) throw new Error('Rendering misslyckades');
      const data = await res.json();
      setRenderResult(`${renderServerUrl}${data.photoUrl}`);
    } catch (err) {
      setRenderError(err instanceof Error ? err.message : 'Okänt fel vid rendering');
    } finally {
      setRenderLoading(false);
    }
  };

  return {
    renderLoading,
    renderResult,
    renderError,
    renderPhoto,
    closeRenderResult: () => setRenderResult(null),
  };
}
